module.exports = __webpack_public_path__ + "img/section3Card1logo1.b256c7d5.png";